var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"centered":"","title":_vm.title,"width":"1000px","maskClosable":false,"destroyOnClose":true},on:{"ok":_vm.onSubmit},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('food-select',{ref:"foodSelect",attrs:{"bodyStyle":{
      height: 'auto',
      maxHeight: 'calc(100vh - 240px)',
      minHeight: '50vh'
    },"isChecked":true,"params":{
      IsPack: false
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }